import { useState } from "react";

export default function ConfirmTransaction(props) {
  const [errors, setErrors] = useState({});
  const [confirmAmount,setConfirmAmount] = useState("");
  const [mpin,setMpin] = useState("");


  const validate = () => {
    const newErrors = errorHandling('payNow');
    setErrors(newErrors);
    if (Object.keys(newErrors).length === 0) {
      props.payNow(confirmAmount,mpin);
    }
  }

  const errorHandling = (type) => {
    const errors = {};
    if (type === 'payNow') {
        if (!confirmAmount.trim()) {
          errors.confirmAmount = 'Amount is required';
        }else if (confirmAmount != props.transactionPopAmount) {
          errors.confirmAmount = 'Amount is not same';
        }else if (!mpin.trim()) {
          errors.mpin = 'Mpin is required';
        }
    }
    return errors;
  };
  return (
    <div className="midde_cont">
      <div className="container-fluid">
        <div className="row column_title">
          <div className="col-md-12">
            <div className="page_title">
              <h2>Confirm Payment</h2>
            </div>
          </div>
        </div>
        <fieldset
        className="checkout-step-3 px-0 body current"
        id="steps-uid-0-p-2"
        role="tabpanel"
        aria-labelledby="steps-uid-0-h-2"
        aria-hidden="false"
        style={{}}
      >
        <h3 className="text-danger">
          If transaction show timeout in money transfer/upi transaction, transaction
          will be update in T+3 Working Days.
        </h3>
        <section id="checkout-payment" className="list-view product-checkout">
          <div className="row">
            <div className="col-md-12 mt-3">
              <div className="payment-type">
                <div className="card">
                  <div className="card-header flex-column align-items-start">
                    <h4 className="card-title">{props.transactionPopServiceName}-{props.transactionPopMethod}-<span>(Amount : <i className="fa fa-inr"></i> {props.transactionPopAmount}) </span></h4>
                  </div>
                  <div className="card-content">
                    <div className="card-body">
                      <ul className="other-payment-options list-unstyled">
                        <li>
                          <div>
                            <span>Mobile Number</span>
                            <span className="float-right">{props.transactionPopMobile}</span>
                          </div>
                        </li>
                        <li>
                          <div>
                            <span>Account Number</span>
                            <span className="float-right">{props.transactionPopAccountNo}</span>
                          </div>
                        </li>
                        <li>
                          <div>
                            <span>Bank Name</span>
                            <span className="float-right">{props.transactionPopBankName}</span>
                          </div>
                        </li>
                        <li>
                          <div>
                            <span>Beneficiary Name</span>
                            <span className="float-right">{props.transactionPopCustomerName}</span>
                          </div>
                        </li>
                      </ul>
                      <div className="d-flex justify-content-between flex-wrap">
                        <div className="card-expiration-date mt-2">
                          Txn Date : 
                          {props.transactionPopTxnDate}
                        </div>
                      </div>
                      <div className="mt-1 row">
                        <div className="col-md-6" />
                        <div className="col-md-3">
                          <lable className="tx-13">Confirm Amount:</lable>
                          <input
                            type="text"
                            className="form-control  input-cvv"
                            id="confirm_amount"
                            placeholder="Confirm Amount"
                            value={confirmAmount}
                            onChange={(e) => { setConfirmAmount(e.target.value) }}
                          />
                          {errors.confirmAmount && (
                            <span className="error-message">
                              {errors.confirmAmount}
                            </span>
                          )}
                        </div>
                        <div className="col-md-3">
                          <lable className="tx-13">Enter PIN:</lable>
                          <input
                            type="password"
                            className="form-control  input-cvv"
                            id="mpin"
                            placeholder="Enter PIN"
                            value={mpin}
                            onChange={(e) => { setMpin(e.target.value) }}
                          />
                          {errors.mpin && (
                            <span className="error-message">
                              {errors.mpin}
                            </span>
                          )}
                        </div>
                      </div>                      
                      <hr />
                      <div className="gift-card">
                        <button
                          className="btn btn-primary btn-cvv mb-3 waves-effect float-right waves-light"
                          onClick={validate}
                        >
                          Pay Now
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </fieldset>
      </div>
    </div>
  );
}